<template>
  <ul class="list-disc pl-6 last:mb-0">
    <slot v-bind="$props" />
  </ul>
</template>

<script setup lang="ts">
import type { Block } from '@contentful/rich-text-types'

defineProps<{
  node: Block
}>()

defineOptions({
  name: 'CMSUnorderedListNode',
})
</script>
